import React from 'react';

type RcpLogoProps = {
  fill: string;
};

export const RcpLogo: React.FC<RcpLogoProps> = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    width="20"
    height="14"
    viewBox="0 0 130 114.5"
  >
    <title>Rich Content Platform dev-tools</title>
    <path
      fill={fill}
      d="m28.22,83.52c0-37.24,22.37-51.78,52-52.54v20.66c-13.79.51-18.9,6.12-18.9,16.58v4.34h17.11v41.14h55.26l-26.8-30.61c3.83-7.57,5.99-16.12,5.99-25.17C112.88,26.86,87.54,1.69,56.29,1.69S-.31,26.86-.31,57.91v55.78h28.53v-30.17Z"
    />
  </svg>
);
